module.exports = __webpack_public_path__ + "img/cashout-active.9ee939b0.svg";